<script>
import { services } from '@utils/common-services'
import { appConfig } from '@src/app.config'
import axios from 'axios'
//  import { ValidationObserver } from 'vee-validate'
export default {
  props: {
    appRight: {
      type: Boolean,
      defult() {
        return false
      },
    },
    toggle: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      mode: null,
      isApplicant: false,
      next: null,
      formapi: appConfig.apiUrl.split('/api/'),
      previous: null,
      status: null,
      updateLoader: false,
      downloadLoader: false,
      formState: 0,
      locked: null,
      waitingForm: null,
      incompletePartner: [],
      incompleteMain: [],
      formLoading: false,
      dataSaved: true,
      jumptouser: null,
      message: null,
      newStatus: null,
      formApi: appConfig.formsUrl,
      showSuccess: null,
      applicantNo: null,
      userProfile: { applicant1: {}, applicant2: {} },
      applicationsMain: [
        {
          name: 'Personal Information',
          percentage: 0,
          code: 'personalInformation',
          expect: null,
        },
        {
          name: 'Household',
          percentage: 0,
          code: 'household',
          expect: null,
        },
        { name: 'Health', percentage: 0, code: 'health', expect: null },
        {
          name: 'Personal References',
          percentage: 0,
          code: 'personalReferences',
          expect: null,
        },
        {
          name: 'Offending History',
          percentage: 0,
          code: 'additionalInformation',
          expect: null,
        },
        {
          name: 'Relationship',
          percentage: 0,
          code: 'relationship',
          expect: null,
        },
        {
          name: 'Fostering Experience',
          percentage: 0,
          code: 'previousExperience',
          expect: null,
        },
        {
          name: 'Employment History',
          percentage: 0,
          code: 'employmentHistory',
          expect: null,
        },
        { name: 'Address', percentage: 0, code: 'address', expect: null },
        {
          name: 'Declaration',
          percentage: 0,
          code: 'declaration',
          expect: null,
        },
      ],
      applicationPartner: [
        {
          name: 'Personal Information',
          percentage: 0,
          code: 'personalInformation',
          expect: null,
        },
        {
          name: 'Household',
          percentage: 0,
          code: 'household',
          expect: null,
        },
        { name: 'Health', percentage: 0, code: 'health', expect: null },

        {
          name: 'Offending History',
          percentage: 0,
          code: 'additionalInformation',
          expect: null,
        },
        {
          name: 'Relationship',
          percentage: 0,
          code: 'relationship',
          expect: null,
        },
        {
          name: 'Fostering Experience',
          percentage: 0,
          code: 'previousExperience',
          expect: null,
        },
        {
          name: 'Employment History',
          percentage: 0,
          code: 'employmentHistory',
          expect: null,
        },
        { name: 'Address', percentage: 0, code: 'address', expect: null },
        {
          name: 'Declaration',
          percentage: 0,
          code: 'declaration',
          expect: null,
        },
      ],
      formMeta: null,
      userDetails: {},
      applicant1Name: null,
      applicantId: null,
      callAutoSave: false,
      classToggle: this.appRight,
      applicantSubmit: false,
      menuToggle: this.toggle,
      minimizeFooter: false,
      activeForm: null,
      activeApplicant: 'main',
      currentFormStatus: 0,
      applications: null,
      applicant1: null,
      applicant2: null,
      userType: 'GRN',
      toaster: { showSuccess: false, message: null },
    }
  },

  watch: {
    appRight(oldVal, newVal) {
      if (oldVal !== newVal) this.classToggle = this.appRight
    },
    toggle(oldVal, newVal) {
      if (this.toggle !== this.menuToggle) this.menuToggle = !this.menuToggle
    },
    classToggle(val, oldVal) {
      if (val !== oldVal) {
        this.scrollToTop()
      }
    },
    menuToggle(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('clickChange', this.menuToggle)
        // console.log(this.menuToggle)
        //  this.setMenubar({ newVal: true })
        /*  this.$root.$emit('changeMenu', {
          data: true,
        }) */
      }
    },
    activeForm(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.changeHashTo()
        // this.menuToggle=!this.menuToggle
      }
    },
  },

  beforeMount() {
    this.formLoading = true
    this.applications = this.applicationsMain
    this.checkApplicant()
  },
  beforeDestroy() {
    this.$root.$off('submitForm')
    this.$root.$off('click')
    this.$root.$off('formLoader')

    this.$root.$off('formStatus')
    this.$root.$off('knobFormTotal')
    this.$root.$off('savedData')
    this.$root.$off('toaster')
    this.$store.commit('jv/clearRecords', { _jv: { type: 'form_status' } })
    this.$store.commit('jv/clearRecords', {
      _jv: { type: 'applicant_profile' },
    })
    this.$store.commit('jv/clearRecords', { _jv: { type: 'application_meta' } })
    //  var doc = this.$refs.multipleUser
    // if (doc !== undefined) doc.innerHtml = ''
  },
  mounted() {
    var index = -1
    var payLoad = {}
    this.$root.$on('submitForm', (data) => {
      this.getIncompleteForms()

      if (data) {
        this.submitStatus()
        this.applicantSubmit = true
      }
    })
    this.$root.$on('click', (data) => {
      this.getAppLink(data)
    })
    this.$root.$on('formLoader', (data) => {
      this.formLoading = data
      //  console.log(this.formLoading)
    })
    this.$root.$on('savedData', (data) => {
      this.dataSaved = data
      if (this.jumptouser !== null && this.dataSaved)
        this.activateApplicant(this.jumptouser)
    })
    this.$root.$on('formStatus', (data) => {
      // console.log(data)
      if (this.applicant1.id === data.user) {
        index = this.applicationsMain.findIndex(
          (element) => element.code === data.name
        )

        if (
          index > -1 &&
          this.applicationsMain[index]['percentage'] !== data.status
        ) {
          this.applicationsMain[index]['percentage'] = data.status

          this.formState = this.formState + 1
          this.$root.$emit('knobFormTotal', true)

          payLoad = {
            status: data.status,
            applicant: 1,
            _jv: {
              type: 'form_status',
              id: this.applicantNo,
            },
          }

          if (this.applicantNo !== undefined)
            this.$store
              .dispatch('jv/patch', [
                payLoad,
                {
                  url:
                    '/applicant/' +
                    this.applicantNo +
                    '/form/' +
                    data.name +
                    '/status',
                  headers: services.getHeaderAuthorization(),
                },
              ])
              .then((response) => {
                //  console.log(response)
              })
              .catch((error) => {
                if (error) {
                }
                //    console.log(error)
              })
        }
      } else {
        //   console.log(data)
        if (this.applicant2 !== null)
          if (this.applicant2.id === data.user) {
            index = this.applicationPartner.findIndex(
              (element) => element.code === data.name
            )
            if (
              index > -1 &&
              this.applicationPartner[index]['percentage'] !== data.status
            ) {
              this.applicationPartner[index]['percentage'] = data.status
              this.formState = this.formState + 1
              this.$root.$emit('knobFormTotal', true)
              payLoad = {
                status: data.status,
                applicant: 2,
                _jv: {
                  type: 'form_status',
                  id: this.applicantNo,
                },
              }
              if (this.applicantNo !== undefined)
                this.$store
                  .dispatch('jv/patch', [
                    payLoad,
                    {
                      url:
                        '/applicant/' +
                        this.applicantNo +
                        '/form/' +
                        data.name +
                        '/status',
                      headers: services.getHeaderAuthorization(),
                    },
                  ])
                  .then((response) => {
                    //  console.log(response)
                  })
                  .catch((error) => {
                    if (error) {
                    }
                    //   console.log(error)
                  })
            }
          }
      }
    })
    if (this.activeForm === null) {
      this.activeForm = this.applications[0].name
      this.getNextPrev(0)
    }
    this.$root.$on('toaster', (data) => {
      this.toaster = data
      this.$bvToast.show('formToaster')
      var parent = this
      setTimeout(() => {
        parent.$bvToast.hide('formToaster')
        this.toaster = { message: null, showSuccess: false }
      }, 1500)
    })
  },
  methods: {
    checkApplicant() {
      let id = null

      var user = services.decodeJWT(services.getAuth())
      // console.log(user)
      if (!user.is_staff) {
        this.userProfile['applicant1'] = services.getCandidatesNameIcon(user)
        id = user.applicant_id

        this.isApplicant = true
        // console.log(this.applicationPartner)
        if (user.applicant_type === 'applicant1') {
          this.applications = this.applicationsMain
        } else {
          this.applications = this.applicationPartner
        }

        var url = window.location.href.split('forms')

        let urlHash = null
        if (url[1] !== '') urlHash = url[0] + 'forms/' + id
        else {
          var hashurl = url[1].split('#')
          if (hashurl[0] === '') urlHash = url[0] + 'forms/' + id + url[1]
        }
        window.history.replaceState(null, null, urlHash)
        this.retriveApplicant(id)
        this.getApplicantsDetails(id, user)
      } else {
        if (
          this.$route.params.id === null ||
          this.$route.params.id === undefined
        ) {
          var url1 = window.location.href
          var parts = url1.split('forms')
          var partsId = parts[1].split('#')
          id = partsId[0]
          this.getApplicantsDetails(id, user)
          this.retriveApplicant(id)
        } else {
          id = this.$route.params.id
          this.getApplicantsDetails(id, user)
          this.retriveApplicant(id)
        }
      }
    },
    retriveApplicant(id) {
      this.$store
        .dispatch('jv/get', [
          'applicant_profile',
          {
            url: '/applicant/profile/' + id + '?include=user,partner',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {})
        .catch((error) => {
          if (error) {
          }
        })
    },
    setFormStatus(target, data) {
      for (var i = 0; i < target.length; i++) {
        target[i].percentage = data[target[i].code]
      }
      return target
    },
    getApplicantsDetails(id, user) {
      this.$store
        .dispatch('jv/get', [
          'application_meta',
          {
            url: '/applicant/profile/' + id + '/meta',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.mode = response.applyingMode
          this.status = response.status
          this.newStatus = this.status
          this.locked = response.isLocked
          //  console.log(response)
          //  this.$store.commit('jv/addRecords',response)
          // console.log(this.$store.getters['jv/get']('applicant_profile'))

          if (this.mode === 'couple' || this.mode === 'couple_single_login') {
            this.applicant2 = response.applicant2
            this.applicant2['formStatusTotal'] = Math.round(
              (response.completionStatus.applicant2 / 9) * 100
            )

            for (var i = 0; i < this.applicationPartner.length; i++) {
              this.applicationPartner[i].percentage =
                response.applicant2FormsStatus[this.applicationPartner[i].code]
            }
          }

          //   var keys = Object.keys(response.user.userProfile)
          for (var j = 0; j < this.applicationsMain.length; j++) {
            this.applicationsMain[j].percentage =
              response.applicant1FormsStatus[this.applicationsMain[j].code]
          }
          // console.log(this.applicationPartner)
          // console.log(this.applicationsMain)
          // this.setFormStatus(this.applicationsMain,response.applicant1FormsStatus)
          this.applicant1 = response.applicant1
          this.applicant1['formStatusTotal'] = Math.round(
            (response.completionStatus.applicant1 / 10) * 100
          )

          // console.log(this.applicant1)
          this.userProfile['applicant1'] = services.getCandidatesNameIcon(
            this.applicant1
          )
          this.userProfile['applicant1'].id = this.applicant1.id
          if (this.mode === 'couple' || this.mode === 'couple_single_login') {
            this.userProfile['applicant2'] = services.getCandidatesNameIcon(
              this.applicant2
            )
            this.userProfile['applicant2'].id = this.applicant2.id
          }

          if (user.is_staff) {
            if (this.activeApplicant === 'main') {
              this.currentFormStatus = this.applicant1.formStatusTotal
              this.applicantId = this.applicant1.id
            } else {
              this.currentFormStatus = this.applicant2.formStatusTotal
              this.applicantId = this.applicant2.id
            }
          } else {
            if (user.applicant_type === 'applicant1') {
              this.applicantId = this.applicant1.id
              this.currentFormStatus = this.applicant1.formStatusTotal
              this.activeApplicant = 'main'
            } else {
              this.activeApplicant = 'partner'
              this.currentFormStatus = this.applicant2.formStatusTotal
              this.applicantId = this.applicant2.id
            }
          }

          this.applicantNo = id

          services.saveToLocalStorage('user', JSON.stringify(this.userProfile))
          this.formLoading = false
        })
        .catch((error) => {
          if (error) {
          }
        })
    },
    /*   getFormMeta(id) {
      return new Promise((resolve) => {
        this.send({
          to: '/candidates/form/meta/' + id,

          state: 'get',
        })
          .then((token) => {
            //  var obj=token.data.attributes
            if (token.data !== undefined) {
              this.userType = state.currentCandidate.type
              this.formMeta = Object.assign({}, token.data.attributes)
              this.formMeta['id'] = id

              id['formMeta'] = this.formMeta

              resolve(true)
            } else throw token
          })
          .catch((error) => {
            resolve(false)

            if (error) {
            }
          })
      })
    }, */
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    activateApplicant(name) {
      //  console.log(name)
      if (!this.dataSaved) {
        this.$root.$emit('callAutoSave', { status: true, data: {} })
        this.jumptouser = name
        /*  this.$nextTick(() => {

          if(this.dataSaved){
          this.activeApplicant = name

          if (name === 'main') {
            this.applications = this.applicationsMain
            this.applicantId = this.applicant1.id
            this.currentFormStatus = this.applicant1.formStatusTotal
          } else {
            this.applications = this.applicationPartner
            this.applicantId = this.applicant2.id
            this.currentFormStatus = this.applicant2.formStatusTotal
          }
          this.activeForm = this.applications[0].name
          this.getNextPrev(0)
          }
        }) */
      } else {
        this.jumptouser = null
        this.activeApplicant = name

        if (name === 'main') {
          this.applications = this.applicationsMain
          this.applicantId = this.applicant1.id
          this.currentFormStatus = this.applicant1.formStatusTotal
        } else {
          this.applications = this.applicationPartner
          this.applicantId = this.applicant2.id
          this.currentFormStatus = this.applicant2.formStatusTotal
        }
        this.activeForm = this.applications[0].name
        this.getNextPrev(0)
      }
      //  console.log(this.applicantId)
    },
    getStatus() {
      //   console.log('here')
      //    alert('here')
      this.$bvModal.show('change-status')
    },
    setLock(id) {
      this.applicantNo = id
      this.$bvModal.show('lock')
    },
    getVerify(id) {
      this.applicantNo = id
      this.$bvModal.show('verify')
    },
    downloadFile() {
      // var status = 0
      /* if (this.mode === 'couple' || this.mode === 'couple_single_login')
        status =
          this.applicant1.formStatusTotal + this.applicant2.formStatusTotal
      else status = this.applicant1.formStatusTotal + 100 */
      /*  if (status === 200) { */
      this.downloadLoader = true
      axios({
        url: this.formapi[0] + '/forms/api/v1/export/' + this.applicantNo,
        method: 'GET',
        responseType: 'arraybuffer', // important
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'attachment',
          Authorization: 'JWT ' + services.getAuth(),
        },
      })
        .then((response) => {
          // console.log(response)
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: 'application/zip' })
          )
          //  window.open(url)
          this.downloadLoader = false
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            this.userProfile.applicant1.fullName +
              '_' +
              this.applicantNo +
              '.zip'
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          if (error) this.downloadLoader = false
        })
      /*  } else {
        this.$bvModal.show('downloadForms')
      } */
    },
    lockApplicant() {
      let id = this.applicantNo

      var payLoad = {
        isLocked: !this.locked,
        _jv: {
          type: 'applicant_profile',
          id: id,
        },
      }
      this.$store
        .dispatch('jv/patch', [
          payLoad,
          {
            url: '/applicant/profile/' + id + '/lock',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.$bvToast.show('form-toaster')
          this.message = 'Changes updated'
          var parent = this
          this.locked = !this.locked
          this.showSuccess = true
          parent.$bvModal.hide('lock')
          setTimeout(() => {
            parent.$bvToast.hide('form-toaster')

            parent.message = null
          }, 4000)
        })
        .catch((error) => {
          if (error.response) {
            this.trySpin = false
            for (let err of error.response.data.errors) {
              this.message = err.detail
            }
          } else {
            this.trySpin = false

            this.message = error.message
          }
          var parent = this
          this.showSuccess = false
          this.$bvToast.show('form-toaster')
          parent.$bvModal.hide('lock')
          setTimeout(() => {
            parent.$bvToast.hide('form-toaster')

            parent.message = null
          }, 4000)
        })
    },
    setVerify() {
      //   let id = this.applicantNo

      var payLoad = {
        verify: this.status !== 'verified',
        _jv: {
          type: 'applicant_profile',
          id: this.applicantNo,
        },
      }
      this.$store
        .dispatch('jv/patch', [
          payLoad,
          {
            url: '/applicant/profile/' + this.applicantNo + '/verify',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.$bvToast.show('form-toaster')
          this.message = 'Changes updated'
          var parent = this
          //  this.locked = !this.locked
          this.showSuccess = true
          this.status = response.status
          parent.$bvModal.hide('verify')
          setTimeout(() => {
            parent.$bvToast.hide('form-toaster')

            parent.message = null
          }, 4000)
        })
        .catch((error) => {
          if (error.response) {
            this.trySpin = false
            for (let err of error.response.data.errors) {
              this.message = err.detail
            }
          } else {
            this.trySpin = false

            this.message = error.message
          }
          var parent = this
          this.showSuccess = false
          this.$bvToast.show('form-toaster')
          parent.$bvModal.hide('verify')
          setTimeout(() => {
            parent.$bvToast.hide('form-toaster')

            parent.message = null
          }, 4000)
        })
    },
    getIncompleteForms() {
      this.incompleteMain = []
      this.incompletePartner = []
      if (this.mode === 'couple' || this.mode === 'couple_single_login') {
        for (var i = 0; i < 9; i++) {
          if (this.applicationPartner[i].percentage === 0)
            this.incompletePartner.push(this.applicationPartner[i].name)
        }
      }
      for (var j = 0; j < 10; j++) {
        if (this.applicationsMain[j].percentage === 0)
          this.incompleteMain.push(this.applicationsMain[j].name)
      }
    },
    submitStatus() {
      //   this.newStatus='submitted'
      // this.setStatus('submitted')

      //  var data = this.$store.getters['jv/get']('form_status')

      if (
        this.incompletePartner.length === 0 &&
        this.incompleteMain.length === 0
      )
        this.$bvModal.show('submit')
      else {
        //  console.log(this.incompletePartner)
        // console.log(this.incompleteMain)
        this.$bvModal.show('incompletesubmit')
      }
    },
    setStatus(status) {
      //  this.updateLoader = true
      //  console.log(this.$store.getters['jv/get']('applicant_profile'))
      this.downloadLoader = true
      var payLoad = {
        status: status,
        _jv: {
          type: 'applicant_profile',
          id: this.applicantNo,
        },
      }
      this.$store
        .dispatch('jv/patch', [
          payLoad,
          {
            url: '/applicant/profile/' + this.applicantNo + '/change_status',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.status = response.status
          this.downloadLoader = false
          this.$bvToast.show('form-toaster')
          this.message = 'Changes updated'
          var parent = this
          this.updateLoader = false
          this.$bvModal.hide('change-status')
          this.$bvModal.hide('submit')
          this.$bvModal.hide('incompletesubmit')
          if (parent.applicantSubmit) this.$bvModal.show('thankyou')
          this.showSuccess = true
          setTimeout(() => {
            parent.$bvToast.hide('form-toaster')
            // if (parent.status === 'submitted' && parent.applicantSubmit) location.reload()

            //     parent.message = null
          }, 4000)
        })
        .catch((error) => {
          //     console.log(error)
          this.downloadLoader = false
          this.updateLoader = false
          if (error.response) {
            this.trySpin = false
            for (let err of error.response.data.errors) {
              this.message = err.detail
            }
          } else {
            this.trySpin = false

            this.message = error.message
          }
          var parent = this
          this.showSuccess = false
          this.$bvToast.show('form-toaster')
          setTimeout(() => {
            parent.$bvToast.hide('form-toaster')
            parent.message = null
          }, 4000)
        })
    },
    reloadPage() {
      this.$bvModal.hide('thankyou')
      location.reload()
    },
    getAppLink(data) {
      //  console.log(data)
      if (data !== undefined) {
        this.jumptouser = null
        var ind = this.applications.findIndex((tab) => tab.name === data.name)
        if (ind > -1) {
          this.setActiveApplication(this.applications[ind], data.show)
        }
      }
    },
    setActiveApplication(data, show) {
      if (show) this.menuToggle = !this.menuToggle
      // console.log(this.dataSaved)
      if (data !== undefined) {
        if (!this.dataSaved)
          this.$root.$emit('callAutoSave', { status: true, data: data })
        else {
          //  console.log('here')
          this.activeForm = data.name
        }
      }

      //  console.log(this.activeForm)
    },
    getNextPrev(index) {
      this.scrollToTop()
      this.next = null
      this.previous = null
      this.next =
        this.applications[index + 1] !== undefined
          ? this.applications[index + 1].name
          : null
      this.previous =
        this.applications[index - 1] !== undefined
          ? this.applications[index - 1].name
          : null
    },
    changeHashTo() {
      var url = window.location.href.split('#')
      var ind = this.applications.findIndex(
        (tab) => tab.name === this.activeForm
      )
      var tabIndex = this.applications[ind]
      this.getNextPrev(ind)
      let urlHash = null
      /*  if (state.currentUser.isStaff) {
        if (url.length === 4) {
          urlHash = url[0] + '#' + tabIndex.code + '#' + url[3]
        } else
          urlHash =
            url[0] + '#' + tabIndex.code + '#' + state.currentCandidate.id
      } else
      */ urlHash =
        url[0] + '#' + tabIndex.code
      window.history.replaceState(null, null, urlHash)
    },
  },
}
</script>
<template>
  <div ref="multipleUser">
    <div :class="$style.mainWraper">
      <div :class="$style.innerWraper">
        <FormBaseApplicationLink
          v-if="activeForm !== null"
          :key="activeApplicant"
          :type="userType"
          :applications="applications"
          :application-list-toggle="menuToggle"
          :active="activeForm"
          :status="currentFormStatus"
          @click="getAppLink"
        />
        <div :class="$style.profileSettings">
          <div :class="$style.bodyContent">
            <div
              v-if="!isApplicant || mode == 'couple_single_login'"
              :class="$style.userDetailsWraper"
            >
              <div class="FL FN-sm">
                <a
                  :class="
                    activeApplicant === 'main'
                      ? [$style.userDetails, $style.active]
                      : [$style.userDetails]
                  "
                  href="javascript:void(0)"
                  @click="activateApplicant('main')"
                >
                  <span :class="$style.userProfileRound">{{
                    userProfile.applicant1.profileIcon
                  }}</span>
                  <h6 :class="$style.userProfileName">{{
                    userProfile.applicant1.fullName
                  }}</h6>
                </a>
                <a
                  v-if="mode === 'couple' || mode == 'couple_single_login'"
                  :class="
                    activeApplicant !== 'main'
                      ? [$style.userDetails, $style.active]
                      : [$style.userDetails]
                  "
                  href="javascript:void(0)"
                  @click="activateApplicant('partner')"
                >
                  <span :class="$style.userProfileRound">{{
                    userProfile.applicant2.profileIcon
                  }}</span>
                  <h6 :class="$style.userProfileName">{{
                    userProfile.applicant2.fullName
                  }}</h6>
                </a>
                <div class="clear d-block d-sm-block d-md-none"></div>
              </div>
              <div class="clear d-block d-sm-block d-md-none"></div>
              <div
                class="clear d-block d-sm-block d-md-none"
                :class="$style.bodyContentBorder"
              ></div>
              <div class="FR FN-sm">
                <div v-if="!isApplicant" :class="$style.userActionsWraper">
                  <div :class="$style.actionButton" class="FL mr15">
                    <a
                      id="dropdown-divider"
                      href="javascript:void(0)"
                      :class="$style.actionGear"
                    >
                      <BIcon
                        :class="$style.actionIcon"
                        icon="gear-fill"
                      ></BIcon>
                    </a>
                    <b-popover
                      target="dropdown-divider"
                      triggers="focus"
                      placement="top"
                      :class="$style.popoverWraper"
                    >
                      <b-list-group flush>
                        <b-list-group-item @click="setLock(applicantNo)">
                          <a
                            href="javascript:void(0)"
                            :class="$style.actionList"
                          >
                            <BIcon
                              :class="$style.completed"
                              icon="lock"
                            ></BIcon>
                            {{ locked ? 'Unlock Applicant' : 'Lock Applicant' }}
                          </a>
                        </b-list-group-item>
                        <b-list-group-item>
                          <a
                            :class="$style.actionList"
                            target="_blank"
                            @click="downloadFile"
                          >
                            <BIcon
                              :class="$style.completed"
                              icon="download"
                            ></BIcon>
                            Download Form
                          </a>
                        </b-list-group-item>
                        <b-list-group-item @click="getStatus">
                          <a
                            href="javascript:void(0)"
                            :class="$style.actionList"
                          >
                            <BIcon
                              :class="$style.completed"
                              icon="card-list"
                            ></BIcon>
                            Change status
                          </a>
                        </b-list-group-item>
                        <b-list-group-item @click="getVerify(applicantNo)">
                          <a
                            href="javascript:void(0)"
                            :class="$style.actionList"
                          >
                            <BIcon
                              :class="$style.completed"
                              icon="check-circle"
                            ></BIcon>
                            {{ status === 'verified' ? 'Unverify' : 'Verify' }}
                          </a>
                        </b-list-group-item>
                      </b-list-group>
                    </b-popover>
                  </div>
                  <h5 :class="$style.userStatus" class="FL">
                    <BIcon
                      :class="$style.actionIcon"
                      class="mr5"
                      icon="kanban-fill"
                    ></BIcon
                    >{{
                      status !== null
                        ? status.charAt(0).toUpperCase() + status.slice(1)
                        : ''
                    }}</h5
                  >
                  <div class="clear"></div>
                </div>
                <div class="clear d-block d-sm-block d-md-none"></div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
          <div :class="isApplicant && locked ? [$style.formLock] : ''">
            <FormBaseForm
              v-if="activeForm !== null && applicantId !== null && !formLoading"
              :key="activeForm + applicantId"
              :user="applicantId"
              :name="activeForm"
              :next="next"
              :previous="previous"
              :applicant="activeApplicant"
              @click="getAppLink($event)"
            />
          </div>

          <!-- Loader -->
          <!-- Loader -->
          <div v-if="downloadLoader" :class="$style.loader">
            <svg
              xmlns:svg="http://www.w3.org/2000/svg"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.0"
              width="64px"
              height="64px"
              viewBox="0 0 128 128"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M78.75 16.18V1.56a64.1 64.1 0 0 1 47.7 47.7H111.8a49.98 49.98 0 0 0-33.07-33.08zM16.43 49.25H1.8a64.1 64.1 0 0 1 47.7-47.7V16.2a49.98 49.98 0 0 0-33.07 33.07zm33.07 62.32v14.62A64.1 64.1 0 0 1 1.8 78.5h14.63a49.98 49.98 0 0 0 33.07 33.07zm62.32-33.07h14.62a64.1 64.1 0 0 1-47.7 47.7v-14.63a49.98 49.98 0 0 0 33.08-33.07z"
                  fill="#ff6017"
                />
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 64 64"
                  to="-90 64 64"
                  dur="400ms"
                  repeatCount="indefinite"
                ></animateTransform>
              </g>
            </svg>
          </div>
          <!-- Loader -->
          <!-- hide loader use class="d-none" below -->
          <div v-if="formLoading" :class="$style.formLoader" class="p30">
            <svg
              role="img"
              width="800"
              height="800"
              aria-labelledby="loading-aria"
              viewBox="0 0 800 800"
              preserveAspectRatio="none"
            >
              <title id="loading-aria">Loading...</title>
              <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                clip-path="url(#clip-path)"
                style='fill: url("#fill");'
              ></rect>
              <defs>
                <clipPath id="clip-path">
                  <rect x="317" y="186" rx="5" ry="5" width="63" height="13" />
                  <rect x="6" y="44" rx="5" ry="5" width="240" height="36" />
                  <rect x="272" y="44" rx="5" ry="5" width="240" height="36" />
                  <rect x="6" y="110" rx="5" ry="5" width="240" height="36" />
                  <rect x="275" y="110" rx="5" ry="5" width="240" height="36" />
                  <rect x="7" y="175" rx="7" ry="7" width="240" height="36" />
                  <rect x="7" y="241" rx="5" ry="5" width="240" height="36" />
                  <rect x="276" y="241" rx="5" ry="5" width="240" height="36" />
                  <circle cx="291" cy="193" r="17" />
                  <circle cx="413" cy="193" r="17" />
                  <rect x="447" y="186" rx="5" ry="5" width="63" height="13" />
                  <rect x="7" y="311" rx="5" ry="5" width="502" height="69" />
                  <rect x="8" y="418" rx="5" ry="5" width="240" height="36" />
                  <rect x="274" y="418" rx="5" ry="5" width="240" height="36" />
                  <rect x="413" y="486" rx="5" ry="5" width="97" height="40" />
                </clipPath>
                <linearGradient id="fill">
                  <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
                    <animate
                      attributeName="offset"
                      values="-2; -2; 1"
                      keyTimes="0; 0.25; 1"
                      dur="2s"
                      repeatCount="indefinite"
                    ></animate>
                  </stop>
                  <stop offset="1.59996" stop-color="#ebebeb" stop-opacity="1">
                    <animate
                      attributeName="offset"
                      values="-1; -1; 2"
                      keyTimes="0; 0.25; 1"
                      dur="2s"
                      repeatCount="indefinite"
                    ></animate>
                  </stop>
                  <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
                    <animate
                      attributeName="offset"
                      values="0; 0; 3"
                      keyTimes="0; 0.25; 1"
                      dur="2s"
                      repeatCount="indefinite"
                    ></animate>
                  </stop>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div v-if="formLoading" :class="$style.formLoaderMobile" class="p30">
            <!-- Loader -->
            <div :class="$style.loader">
              <svg
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.0"
                width="64px"
                height="64px"
                viewBox="0 0 128 128"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M78.75 16.18V1.56a64.1 64.1 0 0 1 47.7 47.7H111.8a49.98 49.98 0 0 0-33.07-33.08zM16.43 49.25H1.8a64.1 64.1 0 0 1 47.7-47.7V16.2a49.98 49.98 0 0 0-33.07 33.07zm33.07 62.32v14.62A64.1 64.1 0 0 1 1.8 78.5h14.63a49.98 49.98 0 0 0 33.07 33.07zm62.32-33.07h14.62a64.1 64.1 0 0 1-47.7 47.7v-14.63a49.98 49.98 0 0 0 33.08-33.07z"
                    fill="#ff6017"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 64 64"
                    to="-90 64 64"
                    dur="400ms"
                    repeatCount="indefinite"
                  ></animateTransform>
                </g>
              </svg>
            </div>
            <!-- Loader -->
          </div>
          <!-- Loader -->
        </div>

        <div class="clear d-xl-block d-sm-block d-md-none"></div>
        <!-- $style.open -->
      </div>
    </div>

    <!--Address Modal popup -->
    <div> </div>
    <!--Address Modal popup -->

    <!--Profile upload Modal popup -->
    <div>
      <b-modal
        id="change-status"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
      >
        <div :class="$style.modalWraper">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Change Status</h3>
            <a
              href="javascript:void(0)"
              :class="$style.modalClose"
              @click="$bvModal.hide('change-status')"
              ><BIcon class="" icon="x" :class="$style.modalCloseIcon"></BIcon
            ></a>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <form :class="$style.form" @submit.prevent="setStatus(newStatus)">
              <CommonBaseSelectDynamic
                v-model="newStatus"
                name="status"
                label="Status"
                :options="{ to: '/applicant/profile' }"
                :valiation="{ required: true }"
                @update="newStatus = $event"
              />

              <div class="clear"></div>
              <div :class="[$style.buttonWrapper]" class=" mt25 tc">
                <button
                  type="button"
                  class="buttonCommon buttonCancel button mr20 mb20-xs"
                  @click="$bvModal.hide('change-status')"
                >
                  Cancel
                </button>
                <button
                  class="buttonCommon buttonPrimary button"
                  type="submit"
                  v-on="$listeners"
                >
                  Change Status
                </button>
              </div>
            </form>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="thankyou"
        centered
        title="Thankyou"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Thankyou!!</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText"
              >Thank you for submitting your application. We have now received
              this and will contact you shortly once the form has been
              processed.
            </p>
            <p :class="$style.modalText">
              Kind Regards,<br />
              <b>Swiis Foster Care Team</b></p
            >
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="reloadPage"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal
        id="lock"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText"
              >Do you want to {{ locked ? 'unlock' : 'lock' }} this
              applicant?</p
            >
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('lock')"
              >
                Cancel
              </button>
              <button
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="lockApplicant"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="downloadForms"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Information</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText"
              >This applicant have some incomplete forms. You can download it
              once they are completed.</p
            >
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('downloadForms')"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="incompletesubmit"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <div :class="$style.modalText">
              <h3 v-if="incompleteMain.length > 0" :class="$style.alertHeader">
                <BIcon icon="exclamation-circle-fill"></BIcon>
                {{
                  incompleteMain.length > 0
                    ? 'You have some incomplete forms:'
                    : ' '
                }}
              </h3>
              <ul :class="$style.incompleteList"
                ><li v-for="form in incompleteMain" :key="form">
                  <BIcon icon="file-earmark-text"></BIcon> {{ form }}
                </li>
              </ul>
              <h3
                v-if="incompletePartner.length > 0"
                :class="$style.alertHeader"
              >
                <BIcon icon="exclamation-circle-fill"></BIcon>
                {{
                  incompletePartner.length > 0
                    ? 'Incomplete forms in partner section: '
                    : ' '
                }}
              </h3>
              <ul :class="$style.incompleteList"
                ><li v-for="forms in incompletePartner" :key="forms">
                  <BIcon icon="file-earmark-text"></BIcon> {{ forms }}
                </li>
              </ul>

              Prior to submission please kindly make sure your partner has also
              completed the online form else the form will be locked from
              further amendment.
            </div>
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('incompletesubmit')"
              >
                Cancel
              </button>
              <button
                v-if="
                  incompleteMain.length <= 0 && incompletePartner.length <= 0
                "
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="setStatus('submitted')"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="submit"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText"
              >Kindly note that once submitted, your application form will be
              locked from further editing.</p
            >
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('submit')"
              >
                Cancel
              </button>
              <button
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="setStatus('submitted')"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="verify"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText"
              >Do you want to
              {{ status === 'verified' ? 'unverify' : 'verify' }} this
              applicant?</p
            >
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('verify')"
              >
                Cancel
              </button>
              <button
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="setVerify"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!--Profile upload Modal popup -->
    <div :class="$style.toasterMainWrap">
      <b-toast id="form-toaster" solid no-auto-hide b-toaster-top-right>
        <div
          class="d-flex"
          :class="
            showSuccess
              ? [$style.loginToasterWraper, $style.success]
              : [$style.loginToasterWraper, $style.error]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.alertHeader {
  font-family: 'OpenSansRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
  font-size: 18px;
  color: #ff5d16;
  text-align: left;
}
.incompleteList {
  display: block;
  padding-left: 20px;
  font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
  text-align: left;

  li {
    display: block;
    margin-bottom: 5px;
  }
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.5);

  svg {
    position: fixed;
    top: calc(50vh - 32px);
    left: calc(50vw - 32px);
  }
}

.formLock {
  pointer-events: none;
  opacity: 0.5;
}
.formLoader {
  display: block;
}

.formLoaderMobile {
  display: none;
}

// Modal
.modalOverall {
  padding: 0;
}
.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalClose {
    position: relative;
    display: block;
    float: right;
    width: 32px;
    height: 32px;
    font-size: 23px;
    line-height: 30px;
    color: #8b8d90;
    text-align: center;
    background: #eceff1;
    border-radius: 50px;

    .modalCloseIcon {
      position: absolute;
      top: 4px;
      left: 5px;
    }
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }

  &.planeModal {
    .modalHeader {
      padding: 25px 30px 5px 30px;
      background: #fff;
      border: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .modalIcon {
      display: block;
      width: 100px;
      height: 100px;
      margin: 20px auto;
      background: url('~@assets/images/information.png') no-repeat;
      transform: scale(0.9);
      transform-origin: top;
    }
    .modalTitle {
      float: none;
      text-align: center;
    }
    .modalText {
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: #818284;
      text-align: center;
    }
    .modalBody {
      padding: 0 30px 40px 30px;
    }
  }
}
// Modal

.mainWraper {
  width: 100%;
  min-height: 100vh;
  padding: 15px;
}

.innerWraper {
  position: relative;
  display: flex;
  overflow: hidden;
  background: $color-body-inner-background;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

.profileSettings {
  float: left;
  width: 100%;
  min-height: 100vh;
}

// Page Title - Info text
.bodyContent {
  float: left;
  width: 100%;

  .contentHeader {
    font-family: 'OpenSansBold', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 22px;
    color: $color-main-title;
  }

  .contentInfo {
    font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 13px;
    color: $color-sub-title;
  }
}

.bodyContentBorder {
  width: 100%;
  height: 2px;
  margin: 0;
  background: #f8f9f9;
}
// Page Title - Info text

// User
.userDetailsWraper {
  border-bottom: 2px solid #f8f9f9;
  .userDetails {
    display: flex;
    float: left;
    padding: 15px 30px;
    text-decoration: none;
    word-break: break-word;
    transition: all ease-in-out 0.2s;

    &:hover,
    &.active {
      background: #f8f9f9;
      transition: all ease-in-out 0.2s;
    }

    .userProfileRound {
      display: block;
      float: left;
      width: 30px;
      height: 30px;
      margin-right: 5px;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 14px;
      line-height: 29px;
      color: #f7a27d;
      text-align: center;
      background: #fff;
      border: 2px solid #f7a27d;
      border-radius: 50px;
    }
    .userProfileName {
      float: left;
      margin-bottom: 0;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 14px;
      line-height: 30px;
      color: #7d7d7d;
    }
  }
  .userActionsWraper {
    padding: 18px 30px;

    hr {
      margin: 0 !important;
    }
    ul {
      padding: 0 !important;

      button {
        padding: 12px 25px !important;
      }
    }
    .button {
      background: #fff !important;

      .actionIcon {
        font-size: 18px;
        color: #8b8d90;
      }
    }

    .userStatus {
      margin: 0;
      font-family: 'RobotoMedium', Helvetica Neue, sans-serif, Apple Color Emoji;
      font-size: 14px;
      line-height: 23px;
      color: #ff5d16;
    }

    .actionButton {
      li {
        button {
          font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
            Apple Color Emoji;
          font-size: 14px;
          color: #808d99;
        }
      }
    }
    .actionGear {
      display: block;
      width: 24px;
      height: 24px;
      padding: 5px;
      background: #ff5d16;
      border-radius: 50px;

      .actionIcon {
        display: block;
        font-size: 14px;
        color: #fff;
        transition: all ease-in-out 0.3s;
      }

      &:hover {
        .actionIcon {
          transition: all ease-in-out 0.3s;
          transform: rotate(45deg);
        }
      }
    }
  }
}
// User

.actionList {
  font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji !important;
  font-size: 14px !important;
  color: #7d7d7d !important;
  text-decoration: none !important;
}

@media (max-width: 767px) {
  .innerWraper {
    display: block !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .mainWraper {
    padding: 0 !important;
  }
  .profileSettings {
    padding: 0;
  }
  .userDetails {
    width: 50%;
  }
  .formLoaderMobile {
    display: block;
  }
  .formLoader {
    display: none;
  }

  .alertHeader {
    font-size: 16px;
  }
}
</style>
